import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { RulesOfPolicyComponent } from './policy/rules-of-policy/rules-of-policy.component';
import { PolicyComponent } from './policy/policy.component';
import { PolicyManagementComponent } from './policy-management.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        RulesOfPolicyComponent,
        PolicyComponent,
        PolicyManagementComponent
    ],
    entryComponents: [PolicyManagementComponent],
    exports: [PolicyManagementComponent]
})
export class PolicyManagementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-management/policy-management.module.ts